import { render } from "./SideBySide.vue?vue&type=template&id=6a4729e0"
import script from "./SideBySide.vue?vue&type=script&lang=js"
export * from "./SideBySide.vue?vue&type=script&lang=js"

import "./SideBySide.vue?vue&type=style&index=0&id=6a4729e0&lang=css"

import exportComponent from "/Users/gareth/Documents/UW/Global Madison Atlas Final/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__